import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const OrderManagment = () => {
  const location = useLocation().pathname;

  const [heading, setHeading] = useState("Booking Management");
  const [tabActive, setTabActive] = useState([]);

  // const [tabActive, setTabActive] = useState(location.pathname);

  useEffect(() => {
    console.log(location.split('/').splice(1))
    setTabActive(location.split('/').splice(1));
  }, [location]);

  console.log(tabActive);

  return (
    <>
    <div className="WrapperArea">
      <div className="WrapperBox">
    {!tabActive.includes('OrderActiveConfirmDetails') &&!tabActive.includes('ViewProductDetailInBooking') &&
          <div>
        <div className="TitleBox mb-2">
          <h2>{heading}</h2>
        </div>
        <div className="CommonLinks">
          <ul>
            <li className={`nav-item ${tabActive.includes('ConfirmedBooking') ? "active" : ""}`}>
              <Link to="/OrderManagment/ConfirmedBooking" className="nav-link">
                Confirmed Booking
              </Link>
            </li>
            <li className={`nav-item ${tabActive.includes('InTransitOrders') ? "active" : ""}`}>
              <Link to="/OrderManagment/InTransitOrders" className="nav-link">
                In-Transit Booking
              </Link>
            </li>
            <li className={`nav-item ${tabActive.includes('OrderCompleted') ? "active" : ""}`}>
              <Link to="/OrderManagment/OrderCompleted" className="nav-link">
                Completed Booking
              </Link>
            </li>
            <li className={`nav-item ${tabActive.includes('OrderReturnd') ? "active" : ""}`}>
              <Link to="/OrderManagment/OrderReturnd" className="nav-link">
                Cancelled Booking
              </Link>
            </li>
          </ul>
        </div>
        </div> 
    }
        <Outlet />
      </div>
    </div>
    </>
  );
};

export default OrderManagment;
